import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColDef, ColumnApi, GridApi, SortChangedEvent } from 'ag-grid-community';
import { RoWSelection } from '../list-grid/list-grid.constant';
import { MultiSortKey } from '../list-grid/list-grid.model';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
})
export class DataGridComponent {
  gridApi: GridApi;
  gridColumnApi: ColumnApi;
  debounceTimeout: ReturnType<typeof setTimeout>;
  private baseDefaultColDef: ColDef = {
    floatingFilterComponent: 'floatingFilterComponent',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    suppressMenu: true,
    suppressMovable: true,
    resizable: true,
  };
  private _defaultColDef: ColDef = this.baseDefaultColDef;

  @Input() columnDefs: ColDef[];
  @Input() rowData: any[];
  @Input() overlayNoRowsTemplate: any;
  @Input()
  set defaultColDef(defaultColumnDef: ColDef) {
    this._defaultColDef = {
      ...this.baseDefaultColDef,
      ...defaultColumnDef,
    };
  }
  @Input() hasMultipleRows: RoWSelection;
  @Input() hasRowAnimation = true;
  @Input() components: any;
  @Input() multiSortKey: MultiSortKey = 'ctrl';
  @Input() pagination: boolean;
  @Input() paginationPageSize: number;

  @Output() gridReady = new EventEmitter();
  @Output() selectionChanged = new EventEmitter();
  @Output() rowClicked = new EventEmitter();
  @Output() rowDataUpdated = new EventEmitter();
  @Output() sortChanged = new EventEmitter();
  @Output() columnResized = new EventEmitter();
  @Output() paginationChanged = new EventEmitter();

  get defaultColDef(): ColDef {
    return this._defaultColDef;
  }

  onGridReady(params): void {
    this.gridApi = params.api;
    this.gridReady.emit(params);
    this.gridApi.setDomLayout('autoHeight');
  }

  public onSelectionChanged(): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.selectionChanged.emit();
    }, 100);
  }

  onRowClicked(params): void {
    this.rowClicked.emit(params.data);
  }

  onRowDataUpdated(): void {
    this.rowDataUpdated.emit();
  }

  onSortChanged(params: SortChangedEvent): void {
    const sortedColumn = params.columnApi
      .getColumnState()
      .filter((col) => col.sort)
      .map((col) => ({ colId: col.colId, sort: col.sort }));
    this.sortChanged.emit(sortedColumn);
  }

  onColumnResized() {
    this.columnResized.emit(this.gridApi);
  }

  onPaginationChanged(event) {
    if (event.newPage) {
      this.paginationChanged.emit(event);
    }
  }
}
